import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _trimInstanceProperty from "@babel/runtime-corejs3/core-js/instance/trim";
import _JSON$stringify from "@babel/runtime-corejs3/core-js/json/stringify";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _Promise from "@babel/runtime-corejs3/core-js/promise";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Papa from "papaparse";
import { Fragment } from "vue-fragment";
import RadioSection from "@Shared/components/sections/radio-section";
import AgentsSelect from "@Broker/@Modules/agents/components/agents-select";
import { showToast } from "@Shared/@Utils/constants";
import { validationMixin } from "vuelidate";
import MaterialInput from "@Shared/components/inputs/material-input";
import { cloneDeep, camelCase } from "lodash";
import { emailMultiple } from "@Shared/@Utils/validation-rules";
import DatepickerInput from "@Shared/components/inputs/datepicker-input.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ContactsChoice",
  components: {
    MaterialInput,
    Fragment,
    RadioSection,
    AgentsSelect,
    DatepickerInput
  },
  mixins: [validationMixin],
  props: {
    creating: {
      type: Boolean,
      required: true
    },
    currentList: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      file: null,
      importedCsvOption: null,
      requiredFields: ["firstName", "lastName", "email"],
      isBroker: this.$auth.session.get().accountDetails.accountType === "broker",
      startDate: {
        type: String,
        default: null
      },
      endDate: {
        type: String,
        default: null
      },
      listToRender: {}
    };
  },
  computed: {
    selectOptions() {
      return [{
        label: this.$t("lists.segments.importContacts"),
        value: false
      }, {
        label: this.$t("lists.segments.addManually"),
        value: true
      }];
    },
    manually: {
      get() {
        return this.currentList.manually;
      },
      set(value) {
        this.$emit("change", _objectSpread(_objectSpread({}, this.currentList), {}, {
          manually: value
        }));
      }
    },
    imported: {
      get() {
        return this.currentList.imported;
      },
      set(value) {
        this.$emit("change", _objectSpread(_objectSpread({}, this.currentList), {}, {
          imported: value
        }));
      }
    },
    clientProfiles: {
      get() {
        return this.currentList.clientProfiles;
      },
      set(value) {
        this.$emit("change", _objectSpread(_objectSpread({}, this.currentList), {}, {
          clientProfiles: value
        }));
      }
    },
    referrerList: {
      get() {
        return this.currentList.referrerList;
      },
      set(value) {
        this.$emit("change", _objectSpread(_objectSpread({}, this.currentList), {}, {
          referrerList: value
        }));
      }
    },
    applications: {
      get() {
        return this.currentList.applications;
      },
      set(value) {
        this.$emit("change", _objectSpread(_objectSpread({}, this.currentList), {}, {
          applications: value
        }));
      }
    },
    withCoapps: {
      get() {
        return this.currentList.withCoapps;
      },
      set(value) {
        this.$emit("change", _objectSpread(_objectSpread({}, this.currentList), {}, {
          withCoapps: value
        }));
      }
    },
    importedList: {
      get() {
        return this.currentList.importedList;
      },
      set(value) {
        this.$emit("change", _objectSpread(_objectSpread({}, this.currentList), {}, {
          importedList: value
        }));
      }
    },
    agentsToImportFrom: {
      get() {
        return this.currentList.agentsToImportFrom;
      },
      set(value) {
        this.$emit("change", _objectSpread(_objectSpread({}, this.currentList), {}, {
          agentsToImportFrom: value
        }));
      }
    },
    csvArray: {
      get() {
        return this.currentList.csvArray;
      },
      set(value) {
        this.$emit("change", _objectSpread(_objectSpread({}, this.currentList), {}, {
          csvArray: value
        }));
      }
    },
    emailList: {
      get() {
        return this.importedList;
      },
      set(value) {
        var _context;
        this.importedList = _mapInstanceProperty(_context = value.split(",")).call(_context, e => _trimInstanceProperty(e).call(e));
      }
    }
  },
  watch: {
    manually(value) {
      this.imported = true;
      if (value) {
        this.resetAutomaticImport();
      } else {
        this.resetManualImport();
      }
    },
    applications() {
      this.imported = true;
    },
    clientProfiles() {
      this.imported = true;
    },
    importedCsvOption(value) {
      this.imported = true;
      if (!value) {
        this.csvArray = [];
        this.file = null;
        this.$refs.fileInput.value = "";
      }
    }
  },
  mounted() {
    if (this.creating) this.importedCsvOption = false;else {
      const initialList = JSON.parse(_JSON$stringify(this.currentList));
      initialList.manually = null;
      initialList.imported = true;
      initialList.importedCsvOption = this.imported && this.csvArray.length;
      this.$emit("change", initialList);
    }
  },
  methods: {
    handleChange(agents, type) {
      var _context2;
      switch (type) {
        case "select":
          this.agentsToImportFrom.push(agents[agents.length - 1].username);
          break;
        case "unselect":
          this.agentsToImportFrom = _filterInstanceProperty(_context2 = this.agentsToImportFrom).call(_context2, username => agents.username !== username);
          break;
      }
    },
    handleChangeRange(range) {
      this.startDate = range.start;
      this.endDateDate = range.end;
      this.listToRender = cloneDeep(this.currentList);
      this.listToRender.interval = range;
      this.$emit("change", this.listToRender);
    },
    loadImportsInput({
      data,
      meta,
      errors
    }) {
      const {
        fields
      } = meta;
      const requiredHeaders = this.requiredFields.every(field => _includesInstanceProperty(fields).call(fields, field));
      if (errors.length > 0 || !requiredHeaders) this.showCSVErrors();
      this.csvArray = data;
    },
    showCSVErrors() {
      $("#select-file").append(`<span class='invalid-feedback'> ${this.$t("lists.importCsv.errorParsingFile")}</span>`);
    },
    hasHeaders({
      fields
    }) {
      const trimmedFields = _mapInstanceProperty(fields).call(fields, field => _trimInstanceProperty(field).call(field));
      return this.requiredFields.every(field => trimmedFields && _includesInstanceProperty(trimmedFields).call(trimmedFields, field));
    },
    trimValue(value) {
      return _trimInstanceProperty(value).call(value);
    },
    beforeFirstChunk(chunk) {
      var _context3;
      const rows = chunk.split(/\r\n|\r|\n/);
      rows[0] = _mapInstanceProperty(_context3 = rows[0].split(/,|;/)).call(_context3, header => {
        let camelCaseHeader = camelCase(header);
        if (camelCaseHeader === "emailAddress") camelCaseHeader = "email";
        return camelCaseHeader;
      }).join(",");
      return rows.join("\r\n");
    },
    parseCSV(file, header) {
      return new _Promise((complete, error) => Papa.parse(file, {
        header,
        skipEmptyLines: true,
        transformHeader: this.trimValue,
        transform: this.trimValue,
        beforeFirstChunk: header ? this.beforeFirstChunk : undefined,
        complete,
        error
      }));
    },
    async handleFileChange({
      currentTarget: input
    }) {
      const file = input.files[0];
      this.file = file;
      let {
        meta,
        data
      } = await this.parseCSV(file, true);
      if (!this.hasHeaders(meta)) ({
        data
      } = await this.parseCSV(file, false));
      const validEmails = _filterInstanceProperty(data).call(data, e => emailMultiple(e.email));
      const numberOfValidEmails = validEmails.length;
      if (!numberOfValidEmails) {
        showToast("error", "noValidEmail");
        this.file = null;
        this.$refs.fileInput.value = "";
      } else if (numberOfValidEmails !== data.length) {
        showToast("info", this.$t("notification-messages.importFromCSVWithInvalid", {
          numberOfValidEmails: numberOfValidEmails,
          numberOfInvalidEmails: data.length - numberOfValidEmails
        }));
      } else {
        showToast("success", this.$t("notification-messages.importFromCSV", {
          numberOfValidEmails: numberOfValidEmails
        }));
      }
      this.csvArray = validEmails;
    },
    resetManualImport() {
      this.importedList = [];
    },
    resetAutomaticImport() {
      var _this$$refs$agentSele;
      this.csvArray = [];
      this.agentsToImportFrom = [];
      this.clientProfiles = false;
      this.referrerList = false;
      this.applications = false;
      this.importedCsvOption = false;
      this.file = null;
      this.$refs.fileInput.value = "";
      (_this$$refs$agentSele = this.$refs.agentSelect) == null ? void 0 : _this$$refs$agentSele.reset();
    }
  }
});